import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
    selector: 'app-tipo-impressao',
    templateUrl: './tipo-impressao-dialog.html',
    styleUrls: ['./tipo-impressao-dialog.scss', '../../../styles/estilo.padrao.scss']
})
export class AlertaTipoImpressaoDialog {

    constructor(
        private dialogRef: MatDialogRef<AlertaTipoImpressaoDialog>,
    ) {
    }

    imprimir(tipo) {
        this.dialogRef.close({ tipo: tipo });
    }
}
